function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var RowHover = /*#__PURE__*/ function() {
    "use strict";
    function RowHover() {
        _class_call_check(this, RowHover);
        _define_property(this, "$cols", document.querySelector('[data-row-hover]').querySelectorAll('.location__item'));
        _define_property(this, "order", locationOrder);
        _define_property(this, "orderIndex", 0);
        _define_property(this, "autoplayTimeout", null);
        _define_property(this, "resumeTimeout", null);
    }
    _create_class(RowHover, [
        {
            key: "handleActive",
            value: function handleActive($el, index) {
                var _this = this;
                var sibling = 0;
                $el.style.width = "".concat(36.9834, "%");
                if (this.$cols[index - 1]) {
                    sibling += 1;
                    this.$cols[index - 1].style.width = "".concat(100 / this.$cols.length, "%");
                }
                if (this.$cols[index + 1]) {
                    sibling += 1;
                    this.$cols[index + 1].style.width = "".concat(100 / this.$cols.length, "%");
                }
                this.$cols.forEach(function($item, itemIndex) {
                    if (![
                        index,
                        index - 1,
                        index + 1
                    ].includes(itemIndex)) {
                        $item.style.width = "".concat((100 - 36.9834 - 100 / _this.$cols.length * sibling) / (_this.$cols.length - 1 - sibling), "%");
                    }
                });
                $el.classList.add('-row-hover-active');
            }
        },
        {
            key: "handleInActive",
            value: function handleInActive($el) {
                this.$cols.forEach(function(item) {
                    return item.removeAttribute('style');
                });
                $el.classList.remove('-row-hover-active');
            }
        },
        {
            key: "handleAutoplay",
            value: function handleAutoplay() {
                var _this = this;
                var index = this.order[this.orderIndex];
                var $el = this.$cols[index];
                this.handleActive($el, index);
                this.autoplayTimeout = setTimeout(function() {
                    _this.handleInActive($el);
                    _this.orderIndex = _this.orderIndex >= _this.order.length - 1 ? 0 : _this.orderIndex + 1;
                    var nextTimeout = setTimeout(function() {
                        _this.handleAutoplay();
                        clearTimeout(nextTimeout);
                    }, 750);
                    clearTimeout(_this.autoplayTimeout);
                }, 2000);
            }
        },
        {
            key: "init",
            value: function init() {
                var _this = this;
                var _this_$cols;
                (_this_$cols = this.$cols) === null || _this_$cols === void 0 ? void 0 : _this_$cols.forEach(function($col, index) {
                    $col.addEventListener('mouseenter', function() {
                        var $active = Array.from(_this.$cols).find(function(item) {
                            return item.classList.contains('-row-hover-active');
                        });
                        if ($active) {
                            _this.handleInActive($active);
                        }
                        clearTimeout(_this.resumeTimeout);
                        clearTimeout(_this.autoplayTimeout);
                        var activeTimeout = setTimeout(function() {
                            _this.handleActive($col, index);
                            clearTimeout(activeTimeout);
                        }, 0);
                    });
                    $col.addEventListener('mouseleave', function() {
                        _this.handleInActive($col);
                        _this.resumeTimeout = setTimeout(function() {
                            _this.handleAutoplay();
                        }, 2750);
                    });
                });
                if (this.order) {
                    this.handleAutoplay();
                }
            }
        }
    ]);
    return RowHover;
}();
export default RowHover;
